"use client";
import React, { Fragment, useState, useEffect } from "react";
import dynamic from "next/dynamic";
const Carousel = dynamic(() => import("@/components/ui/Carousel"), {
  ssr: false,
});
import { SwiperSlide } from "swiper/react";
import { usePartners } from "@/hooks/usePartners";
import Image from "next/image";

export default function PartnersSection() {
  const [membersPerSlide, setMembersPerSlide] = useState(16);
  const partners = usePartners();

  // Update membersPerSlide based on window width
  useEffect(() => {
    const updateMembersPerSlide = () => {
      setMembersPerSlide(window.innerWidth <= 768 ? 4 : 16);
    };
    // Initial update
    updateMembersPerSlide();
    // Update on window resize
    window.addEventListener("resize", updateMembersPerSlide);
    // Cleanup
    return () => {
      window.removeEventListener("resize", updateMembersPerSlide);
    };
  }, []);

  // Calculate the total number of carousels required
  const totalCarousels = Math.ceil(partners.length / membersPerSlide);

  // Generate an array of carousels
  const carousels = Array.from(
    { length: totalCarousels },
    (_, index) => index + 1
  );

  return (
    <Fragment>
      <div className="my-8">
        <div className="xl:container">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 mb-12">
          <div className="flex items-center justify-center">
            <Image alt="" width={889} height={302} src={'https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_about%2Fpartners%2Fv2%2Ffeature_partners%2Fpart_ava_2.png?alt=media&token=5417cf03-af38-4e9f-9210-515edc550ecc'} />
          </div>
          <div className="flex items-center justify-center">
            <Image alt="" width={889} height={302} src={'https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_about%2Fpartners%2Fv2%2Ffeature_partners%2Fpart_ferrum_2.png?alt=media&token=efd34760-84f9-4ae8-a514-09a2f4d6f93f'} />
          </div>
          <div className="flex items-center justify-center">
            <Image alt="" width={889} height={302} src={'https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fpage_about%2Fpartners%2Fv2%2Ffeature_partners%2Fpart_googlecloud_2.png?alt=media&token=575b4913-f7c6-4b55-8f08-eec437e62a31'} />
          </div>
        </div>
        <Carousel pagination={true} navigation={true} className="main-caro">
          {/* Generate slides for each carousel */}
          {carousels.map((carouselIndex) => (
            <SwiperSlide key={carouselIndex}>
              {/* Generate team member slides for each carousel */}
              <div className="grid grid-cols-2 gap-y-4 gap-x-2 md:grid-cols-6 xl:grid-cols-8">
                {partners
                  .slice(
                    (carouselIndex - 1) * membersPerSlide,
                    carouselIndex * membersPerSlide
                  )
                  .map((member, memberIndex) => (
                    <div
                      key={memberIndex}
                      onClick={() => {
                        if (member?.url) {
                          window.open(member.url, "_blank");
                        }
                      }}
                      className={"bg-metaxseed-dark-gray border-2 border-[#3a3a3c] p-2 rounded-lg text-center m-2 flex items-center justify-center" + (member?.url ? " cursor-pointer" : "")}
                    >
                      <div className="mx-auto">
                        <Image
                          src={member?.image}
                          width={401}
                          height={318}
                          alt=""
                          className="w-full h-full"
                        />
                      </div>
                    </div>
                  ))}
              </div>
            </SwiperSlide>
          ))}
        </Carousel>
        </div>
      </div>
    </Fragment>
  );
}
